angular.module('impactx.approval').controller('OCIProductReplaceCatalogSelectionCtrl', OCIProductReplaceCatalogSelectionCtrl);

OCIProductReplaceCatalogSelectionCtrl.$inject = ['$scope', '$mdDialog', 'dataGen', '$config', '$location', '$routeParams', 'contextUserId' , 'approvalItem', 'currentPath'];

function OCIProductReplaceCatalogSelectionCtrl($scope, $mdDialog, dataGen, $config, $location, $routeParams, contextUserId, approvalItem, currentPath) {
    var ctrl = this;

    dataGen.getData($scope, {contextUserId: contextUserId}, "/approval/oci/catalogseleciton").then(function (data) {

    });

    ctrl.cancel = function() {
        $mdDialog.cancel();
    };
    ctrl.toExternalCatalog = function() {
        window.location.href =  $config.baseURL + "/oci/ocipage.jsp?CAT.Id=" + $scope.data.catalogSelection.selected.id +
            "&impactX=true&approvalReplace=" + currentPath + "&approvalItem=" + approvalItem + "&replaceContextUsrId=" + contextUserId;
        $mdDialog.hide();
    };
}